import React, { Component } from "react"
import { compose } from "redux"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import update from "immutability-helper"
import styles from "./styles"

import { withStyles } from "@material-ui/core/styles"
import IconButton from "@material-ui/core/IconButton"
import Cancel from "@material-ui/icons/Cancel"
import Icon from "@material-ui/core/Icon"
import CloseIcon from "@material-ui/icons/Close"
import Typography from "@material-ui/core/Typography"
import TextField from "@material-ui/core/TextField"
import FormControl from "@material-ui/core/FormControl"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import withMobileDialog from "@material-ui/core/withMobileDialog"
import Grid from "@material-ui/core/Grid"

import LoadingIconButton from "../LoadingIconButton"
import LoadingButton from "../../components/LoadingButton"
import { openSnackBar } from "../../actions/snack-bar"
import {
  toggleCreateCalendarDialog,
  _updateUser,
  activateCalendar,
  shareCalendar,
} from "../../actions/users"
import { createEmail } from "../../actions/misc"

class CreateCalendarDialog extends Component {
  constructor(props) {
    super(props)

    this.state = {
      submitting: false,
      user: {
        email: "",
      },
      newEmail: "",
      hideEmail: false,
      setHiddenFields: false,
      addingNewEmail: false,
    }
  }

  handleNewInputChange = e => {
    const fieldName = e.target.name
    const value = e.target.value

    this.setState(
      update(this.state, {
        [fieldName]: {
          $set: value,
        },
      }),
    )
  }
  handleClose = () => {
    this.props.dispatch(toggleCreateCalendarDialog(false))
    this.props.setCanCreateCalendar(false)
  }
  clearState = () => {
    this.setState({})
  }
  addNewEmail = e => {
    const user = this.props.user
    e.preventDefault()
    if (this.state.newEmail === user.email) {
      this.props.dispatch(
        openSnackBar({
          message: "Email is already your primary email",
        }),
      )
      return
    }
    this.setState({ addingNewEmail: true })
    this.props
      .dispatch(createEmail({ email: this.state.newEmail }, user.id))
      .then(res => {
        this.setState({ addingNewEmail: false })
        this.props.dispatch(
          _updateUser({
            id: user.id,
            emails: [
              ...user.emails,
              {
                email: this.state.newEmail,
                id: res.id,
              },
            ],
          }),
        )
        setTimeout(() => {
          this.setState({
            newEmail: "",
          })
        }, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving email address",
          }),
        )
        this.setState({ addingNewEmail: false })
      })
  }
  submit = () => {
    const id = this.props.user.id
    this.setState({ submitting: true })
    this.props.updateHiddenFields(true)
    setTimeout(() => {
      this.props
        .dispatch(activateCalendar(id)) // Pretty sure this line is what's fixing the ability to add roles to shoots
        .then(() => this.props.dispatch(shareCalendar(id)))
        .then(() => {
          this.props.dispatch(
            openSnackBar({ message: "Calendar successfully created" }),
          )
          this.handleClose()
          this.setState({ submitting: false })
        })
        .catch(err => {
          this.setState({ submitting: false })
          this.props.dispatch(
            openSnackBar({
              message: "There was an issue creating your calendar",
            }),
          )
          this.handleClose()
        })
    }, 300)
  }

  share = () => {
    const id = this.props.user.id
    this.setState({ submitting: true })
    this.props.updateHiddenFields(true)
    setTimeout(() => {
      this.props
        .dispatch(shareCalendar(id))
        .then(res => {
          this.props.dispatch(
            openSnackBar({ message: "Calendar has been shared" }),
          )
          this.handleClose()
          this.setState({ submitting: false })
        })
        .catch(err => console.log(err))
    }, 500)
  }

  render() {
    const { fullScreen, classes, user, profileProps } = this.props
    return (
      <Dialog
        className={classes.profileDialog}
        fullScreen={fullScreen}
        open={this.props.createCalendarDialogOpen}
        onClose={this.handleClose}
        onEntered={this.setUpForm}
        onExited={this.clearState}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{ classes: { root: classes.dialogPaper } }}
      >
        <div id="edit-form" noValidate autoComplete="off">
          <DialogTitle disableTypography className={classes.dialogTitle}>
            <Typography variant="h6">Google Calendar Integration</Typography>
            <IconButton onClick={this.handleClose} aria-label="Close">
              <CloseIcon classes={{ root: classes.closeIcon }} />
            </IconButton>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <Grid container spacing={2} style={{ flexDirection: "column" }}>
              <Grid item xs={12} sm={12} style={{ display: "flex" }}>
                <Typography variant="body2">
                  The following emails will be given access to your Crew Mama shoot
                  calendar:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} style={{ display: "flex" }}>
                <Typography variant="body2" color="primary">
                  {user.email}
                </Typography>
              </Grid>
              {!isEmpty(user) &&
                user.emails &&
                user.emails.length > 0 &&
                user.emails
                  // .filter(x => profileProps.hideEmails.indexOf(x.id) === -1)
                  .map((email, index) => (
                    <Grid item xs={12} sm={6} style={{ display: "flex" }}>
                      <div
                        key={email.id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          variant="body2"
                          className={classes.extraLineTypography}
                        >
                          <a href={`mailto:${email.email}`}>{email.email}</a>
                        </Typography>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <LoadingIconButton
                            working={
                              profileProps.removingEmails.indexOf(email.id) > -1
                            }
                            buttonclicked={() => this.props.removeEmail(email)}
                            mergeclasses={classes.cancelIcon}
                          >
                            <Cancel />
                          </LoadingIconButton>
                          <IconButton
                            style={{ marginLeft: "8px" }}
                            onClick={() => {
                              this.props.hideOtherEmail(email.id)
                            }}
                          >
                            <Icon>
                              {user.emails.filter(
                                x => profileProps.hideEmails.indexOf(x.id) > -1,
                              ).length === 0
                                ? "remove_red_eye"
                                : "visibility_off"}
                            </Icon>
                          </IconButton>
                        </div>
                      </div>
                    </Grid>
                  ))}
            </Grid>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={6}
                style={{ display: "flex", alignItems: "center" }}
              >
                <div style={{ width: "100%" }}>
                  <form
                    onSubmit={this.addNewEmail}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <div style={{ width: "100%" }}>
                      <FormControl fullWidth>
                        <TextField
                          type="email"
                          fullWidth
                          name="newEmail"
                          label="Other Email"
                          value={this.state.newEmail}
                          onChange={this.handleNewInputChange}
                          id="newEmail"
                          autoComplete="nope"
                        />
                      </FormControl>
                    </div>
                    <LoadingIconButton
                      working={this.state.addingNewEmail}
                      type="submit"
                    />
                  </form>
                </div>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions
            className={classes.dialogActions}
            classes={{ action: classes.dialogActionsAction }}
          >
            {profileProps.canCreateCalendar === true && (
              <LoadingButton
                color="secondary"
                className={classes.button}
                buttonclicked={this.submit}
                working={this.state.submitting}
                disabled={this.state.submitting}
                type="button"
              >
                Create
              </LoadingButton>
            )}
            {profileProps.canCreateCalendar === false && (
              <LoadingButton
                color="primary"
                className={classes.button}
                buttonclicked={this.share}
                working={this.state.submitting}
                disabled={this.state.submitting}
                type="button"
              >
                Share
              </LoadingButton>
            )}
          </DialogActions>
        </div>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication,
    createCalendarDialogOpen: state.users.createCalendarDialogOpen,
    // createCalendarDialogProps: state.users.createCalendarDialogProps,
    user: state.users.editUser,
  }
}

export default compose(
  connect(
    mapStateToProps,
    null,
  ),
  withStyles(styles, { withTheme: true }),
  withMobileDialog(),
)(CreateCalendarDialog)
